import { render, staticRenderFns } from "./PhysicalAssessmentCSV.vue?vue&type=template&id=c7c5b510&scoped=true&"
import script from "./PhysicalAssessmentCSV.vue?vue&type=script&lang=ts&"
export * from "./PhysicalAssessmentCSV.vue?vue&type=script&lang=ts&"
import style0 from "./PhysicalAssessmentCSV.vue?vue&type=style&index=0&id=c7c5b510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c5b510",
  null
  
)

export default component.exports